export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0\" clip-rule=\"evenodd\"/>"
};